import styled from "@emotion/styled"

export interface StylesProps {
  isSmallWindowHeight: boolean
}

export const ModalWrapper = styled.div<StylesProps>`
  display: flex;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000000;
  width: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "300px" : "400px"};
  overflow: auto;
  padding: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.7rem" : "1rem"};
  background-color: #fff;
  border-radius: 0.3rem;
  justify-content: center;
  box-shadow: 0 0 15px #e2e8f0;
`
